import { useTranslation } from 'react-i18next';
import { LabsList, LabsListEdge } from './LabsList';

type PastLabsProps = {
  labWorks: LabsListEdge[];
};

export const PastLabs = ({ labWorks }: PastLabsProps) => {
  const { t } = useTranslation('labs');

  const empty = labWorks.length === 0;

  return (
    <LabsList
      label={t('PastLabs')}
      labWorks={labWorks}
      isNew={false}
      empty={empty}
    />
  );
};
